import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const FALLBACK_IMAGE = "/nopicture.png";

const useStyles = makeStyles(theme => ({
        messageMedia: {
                objectFit: "cover",
                width: 250,
                height: 200,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
        },
}));

const ModalImageCors = ({ imageUrl }) => {
        const classes = useStyles();
        const [fetching, setFetching] = useState(true);
        const [blobUrl, setBlobUrl] = useState("");

        useEffect(() => {
                setFetching(true);
                setBlobUrl("");

                if (!imageUrl) {
                        setFetching(false);
                        return undefined;
                }

                let objectUrl = "";

                const fetchImage = async () => {
                        try {
                                const { data, headers } = await api.get(imageUrl, {
                                        responseType: "blob",
                                });
                                objectUrl = window.URL.createObjectURL(
                                        new Blob([data], { type: headers["content-type"] })
                                );
                                setBlobUrl(objectUrl);
                        } catch (err) {
                                // Missing file (404) must not retry the broken URL.
                                console.warn(
                                        "Failed to fetch image, using placeholder",
                                        err?.message
                                );
                                setBlobUrl(FALLBACK_IMAGE);
                        } finally {
                                setFetching(false);
                        }
                };
                fetchImage();

                return () => {
                        if (objectUrl) {
                                window.URL.revokeObjectURL(objectUrl);
                        }
                };
        }, [imageUrl]);

        if (!imageUrl) {
                return (
                        <img
                                className={classes.messageMedia}
                                src={FALLBACK_IMAGE}
                                alt="image"
                        />
                );
        }

        return (
                <ModalImage
                        className={classes.messageMedia}
                        smallSrcSet={fetching ? imageUrl : blobUrl}
                        medium={fetching ? imageUrl : blobUrl}
                        large={fetching ? imageUrl : blobUrl}
                        alt="image"
                />
        );
};

export default ModalImageCors;
